import { isScrolledIntoView } from "./utilities";
import { boolToInt } from "./utilities";

document.addEventListener("DOMContentLoaded", handleVideos);

function handleVideos() {
    const videos = document.querySelectorAll(".js-youtube-cont");
    if (videos.length === 0) return;

    const youtubeScript = document.createElement("script");
    youtubeScript.src = "https://www.youtube.com/iframe_api";

    document.body.appendChild(youtubeScript);

    window.addEventListener("youtubeScriptLoaded", () => {
        youtubeScript.addEventListener("load", createYouTubeVideos(videos));
    });
}

const isHubPage = document.querySelector(".page-template-hub-page");

export const createYouTubeVideos = (videos) => {
    videos.forEach((video) => {
        const isVideoCarousel = video.classList.contains("carousel-video__video");

        if (isHubPage && !isVideoCarousel) {
            if (video.querySelector("iframe")) return;
            createYoutubePlayer(video);
        } else {
            videoObserver.observe(video);
        }
    });
};

const videoObserver = new window.IntersectionObserver(
    ([entry]) => {
        const targetInView = entry.intersectionRatio > 0;

        if (!targetInView) return;

        createYoutubePlayer(entry.target);
    },
    { threshold: 0.5 }
);

function createYoutubePlayer(video) {
    videoObserver.unobserve(video);

    const videoFrame = document.createElement("div");
    video.prepend(videoFrame);

    const isHubPage = document.querySelector(".page-template-hub-page");

    const {
        dataset: { autoplay = 0, vidId, hideControls },
    } = video;

    const player = new YT.Player(videoFrame, {
        height: "100%",
        width: "100%",
        videoId: vidId,
        playerVars: {
            rel: 0,
            modestbranding: 1,
            playsinline: 1,
            controls: boolToInt(!hideControls),
            autoplay,
            mute: autoplay,
            loop: autoplay,
            ...(autoplay && { playlist: vidId }),
        },
        events: {
            onReady: onPlayerReady(video, autoplay),
            onStateChange: onPlayerStateChange(video, isHubPage),
        },
    });

    if (isHubPage && !autoplay) {
        isScrolledIntoView(video, () => {
            stopVideo(video, player);
        });
    }

    window.addEventListener("carouselChanged", () => {
        stopVideo(video, player);
    });

    if (isHubPage) {
        const videoCard = video.closest(".video-card");
        if (!videoCard) return;

        const options = {
            attributes: true,
        };

        const observer = new MutationObserver((mutationList, observer) => {
            mutationList.forEach(function (mutation) {
                if (mutation.type === "attributes" && mutation.attributeName === "class") {
                    if (!mutation.target.classList.contains("video-playing")) {
                        stopVideo(video, player);
                    }
                }
            });
        });

        observer.observe(videoCard, options);
    }
}

function onPlayerReady(video, autoplay) {
    return (event) => {
        if (autoplay) {
            isScrolledIntoView(video, playPauseVideo(autoplay, event.target));
        }

        const playBtn = video.parentElement.querySelector(".js-play-btn");

        if (!playBtn) return;

        playBtn.classList.add("ready");

        playBtn.addEventListener("click", () => {
            video.classList.add("playing");
            event.target.playVideo();
        });
    };
}

function onPlayerStateChange(video, isHubPage) {
    return (event) => {
        if (isHubPage && event.data == 0) {
            video.classList.remove("playing");
        }
    };
}

function playPauseVideo(autoplay, player) {
    return (entry) => {
        if (autoplay) {
            entry.isIntersecting ? player.playVideo() : player.pauseVideo();
        }
    };
}

function stopVideo(video, player) {
    const isPlaying = video.classList.contains("playing");

    if (!isPlaying) return;

    player.stopVideo();
    video.classList.remove("playing");
}
